import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year3/Spring/FractionsA/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'FractionsA',
  field: 'Number',
  weeks: [7, 9],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/FractionsA/1UnderstandTheDenominatorsOfUnitFractions" */ './1UnderstandTheDenominatorsOfUnitFractions'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/FractionsA/2CompareAndOrderUnitFractions" */ './2CompareAndOrderUnitFractions'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/FractionsA/3UnderstandTheNumeratorsOfNonUnitFractions" */ './3UnderstandTheNumeratorsOfNonUnitFractions'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/FractionsA/4UnderstandTheWhole" */ './4UnderstandTheWhole'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/FractionsA/5CompareAndOrderNonUnitFractions" */ './5CompareAndOrderNonUnitFractions'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/FractionsA/6FractionsAndScales" */ './6FractionsAndScales'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/FractionsA/7FractionsOnANumberLine" */ './7FractionsOnANumberLine'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/FractionsA/8CountInFractionsOnANumberLine" */ './8CountInFractionsOnANumberLine'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/FractionsA/9EquivalentFractionsOnANumberLine" */ './9EquivalentFractionsOnANumberLine'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Spring/FractionsA/10EquivalentFractionsAsBarModels" */ './10EquivalentFractionsAsBarModels'
        )
    })
  ]
});
export default Block;
